'use client';

import React from 'react';
import type { ElementType } from 'react';
import { Header as AriaHeader } from 'react-aria-components';
import { cx } from '@milanote/roma/utils/cx';
import type { PolymorphicProps } from '../../../types/polymorphic';

const COMMAND_MENU_HEADER_DISPLAY_NAME = 'RomaCommandMenuHeader';
const commandMenuHeaderClassName = 'px-2.5 py-2 text-md font-semibold text-primary';

type CommandMenuHeaderOwnProps = {
    className?: string;
};

type CommandMenuHeaderBaseComponentProps<T extends ElementType> = PolymorphicProps<CommandMenuHeaderOwnProps, T>;

export type CommandMenuHeaderBaseProps = PolymorphicProps<CommandMenuHeaderOwnProps>;

export const CommandMenuHeaderBase = <T extends ElementType = 'div'>(props: CommandMenuHeaderBaseComponentProps<T>) => {
    const { as, className, ...restProps } = props;
    const Component = as ?? 'div';

    return (
        <Component
            {...restProps}
            className={cx(COMMAND_MENU_HEADER_DISPLAY_NAME, commandMenuHeaderClassName, className)}
        />
    );
};

export type CommandMenuHeaderProps = React.ComponentPropsWithoutRef<typeof AriaHeader>;

export const CommandMenuHeader: React.FC<CommandMenuHeaderProps> = ({ className, ...props }) => (
    <CommandMenuHeaderBase as={AriaHeader} {...props} className={cx(COMMAND_MENU_HEADER_DISPLAY_NAME, className)} />
);

CommandMenuHeaderBase.displayName = COMMAND_MENU_HEADER_DISPLAY_NAME;
CommandMenuHeader.displayName = COMMAND_MENU_HEADER_DISPLAY_NAME;
